import React from 'react';

const MinimalistTemplate = ({ resumeData }) => {
    return (
        <div className="bg-white w-[210mm] min-h-[297mm] shadow-2xl origin-top transform scale-[0.4] md:scale-[0.65] lg:scale-[0.85] xl:scale-100 transition-transform duration-300 p-[20mm] text-slate-800 font-sans" id="resume-preview">

            {/* Header */}
            <div className="text-center mb-12">
                <h1 className="text-4xl font-light tracking-widest uppercase mb-4 text-slate-900">{resumeData.personal.fullName || "Your Name"}</h1>
                <div className="flex justify-center flex-wrap gap-6 text-xs tracking-wider text-slate-500 uppercase">
                    {resumeData.personal.email && <span>{resumeData.personal.email}</span>}
                    {resumeData.personal.phone && <span>{resumeData.personal.phone}</span>}
                    {resumeData.personal.location && <span>{resumeData.personal.location}</span>}
                </div>
            </div>

            {/* Summary */}
            {resumeData.personal.summary && (
                <div className="mb-10">
                    <p className="text-sm leading-7 text-slate-600 text-center max-w-2xl mx-auto">{resumeData.personal.summary}</p>
                </div>
            )}

            {/* Dynamic Sections */}
            <div className="space-y-10">
                {resumeData.sectionOrder.map((sectionId) => {
                    if (sectionId === 'experience' && resumeData.experience.length > 0) {
                        return (
                            <div key={sectionId}>
                                <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 text-center mb-8">Experience</h2>
                                <div className="space-y-8">
                                    {resumeData.experience.map((exp) => (
                                        <div key={exp.id} className="grid grid-cols-[1fr_3fr] gap-6">
                                            <div className="text-right">
                                                <div className="text-sm font-semibold text-slate-800">{exp.company}</div>
                                                <div className="text-xs text-slate-400 mt-1">{exp.startDate} - {exp.endDate}</div>
                                                {exp.location && <div className="text-xs text-slate-400">{exp.location}</div>}
                                            </div>
                                            <div>
                                                <h3 className="text-sm font-bold text-slate-800 mb-2">{exp.role}</h3>
                                                <p className="text-sm leading-relaxed text-slate-600 whitespace-pre-line">{exp.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    }

                    if (sectionId === 'education' && resumeData.education.length > 0) {
                        return (
                            <div key={sectionId}>
                                <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 text-center mb-8">Education</h2>
                                <div className="space-y-6">
                                    {resumeData.education.map((edu) => (
                                        <div key={edu.id} className="grid grid-cols-[1fr_3fr] gap-6">
                                            <div className="text-right">
                                                <div className="text-sm font-semibold text-slate-800">{edu.school}</div>
                                                <div className="text-xs text-slate-400 mt-1">{edu.year}</div>
                                            </div>
                                            <div>
                                                <div className="text-sm text-slate-600">{edu.degree} {edu.location && `• ${edu.location}`}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    }

                    if (sectionId === 'skills' && resumeData.skills.length > 0) {
                        return (
                            <div key={sectionId}>
                                <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 text-center mb-6">Skills</h2>
                                <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 max-w-2xl mx-auto">
                                    {resumeData.skills.map((skill, idx) => (
                                        <span key={idx} className="text-sm text-slate-600">
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        );
                    }

                    if (typeof sectionId === 'number') {
                        const section = resumeData.customSections.find(s => s.id === sectionId);
                        if (section && section.items.length > 0) {
                            return (
                                <div key={sectionId}>
                                    <h2 className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 text-center mb-8">{section.title}</h2>
                                    <div className="space-y-6">
                                        {section.items.map((item) => (
                                            <div key={item.id} className="grid grid-cols-[1fr_3fr] gap-6">
                                                <div className="text-right">
                                                    <div className="text-sm font-semibold text-slate-800">{item.title}</div>
                                                    {item.subtitle && <div className="text-xs text-slate-400 mt-1">{item.subtitle}</div>}
                                                </div>
                                                <div>
                                                    {item.subtext && <div className="text-sm font-medium text-slate-700 mb-1">{item.subtext}</div>}
                                                    {item.description && <p className="text-sm leading-relaxed text-slate-600 whitespace-pre-line">{item.description}</p>}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        }
                    }

                    return null;
                })}
            </div>
        </div>
    );
};

export default MinimalistTemplate;
